const ASSIGNLINK = {
  ASSIGN_LINK_HEADER: 'تخصیص لینک به اپراتور',
  ASSIGN_LINK_OPERATOR_SELECT_LABEL: 'انتخاب اپراتور',
  ASSIGN_LINK_OPERATOR_SELECT_TITLE: 'انتخاب اپراتور',
  ASSIGN_LINK_INPUT_LABEL: 'لینک',
  ASSIGN_LINK_GENERAL_PAGES_TITLE: 'تمامی صفحات عمومی',
  ASSIGN_LINK_GENERAL_PAGES_DESCRIPTION:
    'صفحاتی که هیچ اپراتوری برای آنها مشخص نشده است',
  ASSIGN_LINK_FILL_ALL_FIELDS_ERROR: 'لطفا تمامی فیلد ها را پر کنید.',
  ASSIGN_LINK_SAVE_BTN_LABEL: 'ذخیره',
  ASSIGN_LINK_TO_OPERATOR_DESC:
    'با این قابلیت، به جای ایجاد تیم‌ها، می‌توانید مستقیماً یک اپراتور را به صفحه خاصی اختصاص دهید. این اپراتور مسئولیت پاسخگویی به تمام مکالمات صورت گرفته در آن صفحه را بر عهده خواهد داشت.',
  ERROR_MESSAGE: 'پر کردن تمامی فیلدها الزامی می‌باشد!',
  URL_ERROR_MESSAGE: 'وارد کردن لینک (url) ضروری می‌باشد!',
  OPERATOR_ERROR_MESSAGE: 'انتخاب اپراتور ضروری می‌باشد!',
};

export default ASSIGNLINK;
